module.exports = __webpack_public_path__ + "img/nyzjdh.1867c2ce.png";